import { css } from "@emotion/css";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import { useCallback, useState } from "react";

interface Options {
	containerSelector?: string;
	threshold?: number;
}

const hideClass = css`
	transform: translateY(-100%);
	transition: transform 0.3s ease;
`;

const showClass = css`
	transform: translateY(0);
	transition: transform 0.3s ease;
`;

export function useHideOnModalScroll({
	containerSelector = ".modal--content",
	threshold = 50,
}: Options = {}) {
	const [container, setContainer] = useState<HTMLElement | null>(null);

	const anchorRef = useCallback(
		(el: HTMLElement | null) => {
			if (!el) return;
			const found = el.closest(containerSelector) as HTMLElement | null;
			if (found) {
				setContainer((prev) => prev ?? found);
			}
		},
		[containerSelector],
	);

	const hidden = useScrollTrigger({
		target: container ?? undefined,
		threshold,
	});

	return {
		anchorRef,
		hidden,
		transformClass: hidden ? hideClass : showClass,
	};
}
